export default __webpack_public_path__ + "static/media/hub-nav-guide.da9f7a76.svg";